import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class PathwayResolver {
  constructor(connection) {
    this.connection = connection;
  }

  /**
   * creates a pathway.
   * @param {Object} payload
   * @param {string} payload.activityId
   * @param {string} payload.pathwayType E.g., LINEAR, FREE, GRAPH, RANDOM
   * @returns {Promise.<PathwayDTO>}
   */
  authorPathwayCreate = async ({ activityId, pathwayType, preloadPathway }) => {
    const message = {
      type: constants.RTM_AUTHOR_PATHWAY_CREATE,
      activityId,
      pathwayType,
      preloadPathway,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PATHWAY_CREATE_OK,
      constants.RTM_AUTHOR_PATHWAY_CREATE_ERROR,
    );
    return response.pathway;
  };

  /**
   * Deletes a pathway. See
   *   [RTM Docs](https://dev-developers.smartsparrow.com/messages/author-pathway-delete/)
   * @param {Object} payload
   * @param {string} payload.pathwayId
   * @param {string} payload.parentActivityId
   * @returns {Promise.<string>}
   */
  authorPathwayDelete = async ({ pathwayId, parentActivityId }) => {
    const message = {
      type: constants.RTM_AUTHOR_PATHWAY_DELETE,
      pathwayId,
      parentActivityId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PATHWAY_DELETE_OK,
      constants.RTM_AUTHOR_PATHWAY_DELETE_ERROR,
    );
    return response.pathwayId;
  };

  /**
   * Fetches a pathway from the RTM. See
   *   [RTM Docs](https://dev-developers.smartsparrow.com/messages/author-pathway-get/)
   * @param {Object} payload
   * @param {string} payload.pathwayId
   * @param {Promise.<PathwayDTO>}
   */
  authorPathwayGet = async ({ pathwayId }) => {
    const message = {
      type: constants.RTM_AUTHOR_PATHWAY_GET,
      pathwayId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PATHWAY_GET_OK,
      constants.RTM_AUTHOR_PATHWAY_GET_ERROR,
    );
    return response.pathway;
  };

  /**
   * Alters the order of the walkables by replacing the current list with
   * an new ordered list. See
   *   [RTM Docs](https://dev-developers.smartsparrow.com/messages/author-pathway-walkable-reorder/)
   * @param {Object} payload
   * @param {string} payload.pathwayId
   * @param {[string]} payload.walkableIds
   * @param {Promise.<void>}
   */
  authorPathwayWalkableReorder = async ({ pathwayId, walkableIds }) => {
    const message = {
      type: constants.RTM_AUTHOR_PATHWAY_WALKABLE_REORDER,
      pathwayId,
      walkableIds,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PATHWAY_WALKABLE_REORDER_OK,
      constants.RTM_AUTHOR_PATHWAY_WALKABLE_REORDER_ERROR,
    );
    return response;
  };

  authorPathwayConfigReplace = async ({ pathwayId, config }) => {
    const message = {
      type: constants.RTM_AUTHOR_PATHWAY_CONFIG_REPLACE,
      pathwayId,
      config,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PATHWAY_CONFIG_REPLACE_OK,
      constants.RTM_AUTHOR_PATHWAY_CONFIG_REPLACE_ERROR,
    );
    return response;
  };
}

export default PathwayResolver;
